module.exports = __webpack_public_path__ + "img/superior.4a55946e.jpg";